var render = function (_h,_vm) {var _c=_vm._c;return _c('small',_vm._g({staticClass:"stakeholder-helper text-tertiary cursor-pointer"},_vm.listeners),[_c('i',{staticClass:"fas fa-plus q-mr-sm"}),_vm._v(" "+_vm._s(_vm.props.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }